export default __webpack_public_path__ + "static/media/logistics.571c881d.jpg";